var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelegateC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.33 27.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .prefix__cls-1 {\n        fill: #003a47\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__delegate-c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M21.64 1.5a5.6 5.6 0 110 11.19 5.53 5.53 0 01-3.95-1.64 5.59 5.59 0 013.95-9.55m0 14.47c4.3 0 12.19 2.24 12.19 5.91v2.45H9.46v-2.45c0-3.67 7.89-5.91 12.18-5.91m0-15.47a6.6 6.6 0 000 13.19 6.6 6.6 0 100-13.19zm0 14.47c-4.4 0-13.18 2.32-13.18 6.91v3.45h26.37v-3.45c0-4.59-8.78-6.91-13.19-6.91z",
    transform: "translate(-.5 -.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 27.92v-3c0-4.18 8.44-6.46 12.78-6.46s12.78 2.28 12.78 6.46v3zm12.77-11.73a6.14 6.14 0 116.15-6.14 6.11 6.11 0 01-6.15 6.14z",
    transform: "translate(-.5 -.5)",
    fill: "#addccd"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-1",
    d: "M13.78 4.41a5.64 5.64 0 110 11.28 5.63 5.63 0 01-5.64-5.64 5.65 5.65 0 015.64-5.64m0 14.57c4.33 0 12.28 2.26 12.28 6v2.48H1.5v-2.52c0-3.7 8-6 12.28-6m0-15.57a6.64 6.64 0 100 13.28 6.64 6.64 0 100-13.28zm0 14.57C9.35 18 .5 20.32.5 24.94v3.48h26.56v-3.48c0-4.62-8.85-7-13.28-7z",
    transform: "translate(-.5 -.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegateC);
export default __webpack_public_path__ + "static/media/delegate-c.df770cee.svg";
export { ForwardRef as ReactComponent };